import isNil from 'lodash/isNil';

const REGEX_ADD_COMMA = /\B(?=(\d{3})+(?!\d))/g;
export function formatWithCommas(value: number): string {
  if (isNil(value)) {
    return '-';
  }
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(REGEX_ADD_COMMA, ',');
  return parts.join('.');
}
